import PropTypes from "prop-types";
import ReactToPrint from "react-to-print";
import { Button, Image } from "react-bootstrap";
import { useLoading } from "../context/LoadingContext";
import { PrinterIcon } from "../data/iconImage";

const PrintButton = ({ componentRef, button }) => {
  const { setLoading } = useLoading(false);

  const handleOnBeforeGetContent = () => {
    setLoading(true);

    return new Promise((resolve) => {
      setTimeout(() => {
        setLoading(false);
        resolve();
      }, 1000);
    });
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        variant={button?.variant || "outline-light"}
        className={
          button?.className || "px-2 rounded-circle position-absolute border-0"
        }
        style={button?.style || { zIndex: 10, top: "125px", right: "75px" }}
      >
        {button?.icon || (
          <Image
            src={PrinterIcon}
            alt="Printer Icon"
            style={{ width: "24px", height: "24px" }}
          />
        )}
        {button?.name || ""}
      </Button>
    );
  };

  return (
    <ReactToPrint
      removeAfterPrint
      trigger={reactToPrintTrigger}
      content={() => componentRef.current}
      onBeforeGetContent={handleOnBeforeGetContent}
    />
  );
};

PrintButton.propTypes = {
  componentRef: PropTypes.object,
  button: PropTypes.object
};

export default PrintButton;
